module.exports = __webpack_public_path__ + "static/images/wz.825ce5c.png";